import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const vehiclesRoutes: Routes = [
  {
    path: 'vehicles',
    title: 'Technische Betriebsmittel',
    loadComponent: () => import('./vehicles-list/vehicles-list').then(m => m.VehiclesListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'vehicles/new',
    title: 'Neues technisches Betriebsmittel',
    loadComponent: () => import('./vehicle-form/vehicle-form').then(m => m.VehicleFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'vehicles/:id/edit',
    title: 'Technisches Betriebsmittel bearbeiten',
    loadComponent: () => import('./vehicle-form/vehicle-form').then(m => m.VehicleFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
